import * as React from 'react';
import { createContext, useCallback, useEffect, useRef, useState } from 'react';
import CollapsedButton from '/react4xp/parts/ai-assistant/components/collapsed-button';
import VirtualAssistantOpen from '/react4xp/parts/ai-assistant/components/virtual-assistant-open';
import './virtual-assistant.scss';

export const PartContext = createContext(null);

const AIAssistant = (props: any) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);

    if (!props.config.isEnabled2) return null;

    return (
        <PartContext.Provider
            value={{
                language: props.language,
                translations: props.translations,
                config: props.config,
            }}
        >
            {isOpen ? (
                <VirtualAssistantOpen
                    language={props.language}
                    token={props.token}
                    translations={props.translations}
                    close={close}
                />
            ) : (
                <CollapsedButton
                    translations={props.translations}
                    openChat={open}
                />
            )}
        </PartContext.Provider>
    );
};

export default AIAssistant;
